import { render, staticRenderFns } from "./TaxonomySearch.vue?vue&type=template&id=38a2d238&"
import script from "./TaxonomySearch.vue?vue&type=script&lang=js&"
export * from "./TaxonomySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports